import React from 'react';

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null; key: number }> {
  state = { error: null as Error | null, key: 0 };
  static getDerivedStateFromError(error: Error){ return { error }; }
  componentDidCatch(error: Error, info: any){ console.error('ErrorBoundary caught error', error, info); }
  handleRetry = () => this.setState(s => ({ error: null, key: s.key + 1 }));
  render(){
    if(this.state.error){
      return (
        <div style={{ padding:40, fontSize:12 }} role="alert">
          Something went wrong.
          <button onClick={this.handleRetry} style={{ fontSize:12, marginLeft:10 }}>Retry</button>
        </div>
      );
    }
    return <React.Fragment key={this.state.key}>{this.props.children}</React.Fragment>;
  }
}

export default ErrorBoundary;